import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { InsuranceAuditAdminView } from '../components/views/insuranceAuditAdminView'
import { Page, PageHeader } from '../ui'

function InsuranceAuditAdmin() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!dataReady && !loading) {
            Loading.circle('Loading...')
            setLoading(true)
            checkAuth()
        }
    }, [dataReady, loading])

    const checkAuth = async () => {
        try {
            // Admin-only page — same gate pattern as /users.
            await api('/insurance-audit-admin-auth')
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response?.status === 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else if (error?.response?.status === 403) {
                Report.failure(
                    'Access Denied',
                    'This page is restricted to admin users only. Please contact your administrator if you need access.',
                    'Return to Dashboard',
                    () => {
                        navigate('/home')
                    },
                )
            } else {
                Report.failure('Access Denied', 'You do not have permission to view this page.', 'Okay', () => {
                    navigate('/home')
                })
            }
        }
    }

    return (
        <div className="insuranceAuditAdmin">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Admin"
                        title="Insurance Audit Admin"
                        intro="Choose which clients appear in the insurance audit and manage the audit list."
                    />
                    {dataReady ? <InsuranceAuditAdminView /> : <></>}
                </Page>
            </MainView>
        </div>
    )
}

export default InsuranceAuditAdmin
